import {
  ALL_SAVED_SEARCH_SET,
  ALL_SAVED_SEARCH_REQ,
  ALL_SAVED_SEARCH_SUCCESS,
  ALL_SAVED_SEARCH_ERROR,
  ALL_SAVED_SEARCH_RESET_STATUS,
  GET_SAVED_SEARCH_REQ,
  GET_SAVED_SEARCH_SUCCESS,
  GET_SAVED_SEARCH_ERROR,
  GET_SAVED_SEARCH_RESET_STATUS,
  SAVED_SEARCH_POST,
  SAVED_SEARCH_POST_SUCCESS,
  SAVED_SEARCH_POST_ERROR
} from './saved-search.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Base from '@/resources/Base'

const state = {
  allSavedSearchesStatus: '',
  allSavedSearches: {},
  getSavedSearchStatus: '',
  getSavedSearch: {},
  postSavedSearchStatus: ''
}

const getters = {
  allSavedSearchesStatus: state => state.allSavedSearchesStatus,
  allSavedSearches: state => state.allSavedSearches,
  getSavedSearchStatus: state => state.getSavedSearchStatus,
  getSavedSearch: state => state.getSavedSearch,
  postSavedSearchStatus: state => state.postSavedSearchStatus
}

const mutations = {
  [ALL_SAVED_SEARCH_SET]: (state, data) => {
    state.allSavedSearches = data
  },
  [ALL_SAVED_SEARCH_REQ]: state => {
    state.allSavedSearchesStatus = 'loading'
  },
  [ALL_SAVED_SEARCH_SUCCESS]: state => {
    state.allSavedSearchesStatus = 'saved'
  },
  [ALL_SAVED_SEARCH_ERROR]: state => {
    state.allSavedSearchesStatus = 'error'
  },
  [GET_SAVED_SEARCH_REQ]: (state, data) => {
    state.getSavedSearchStatus = 'loading'
  },
  [GET_SAVED_SEARCH_SUCCESS]: state => {
    state.getSavedSearchStatus = 'saved'
  },
  [GET_SAVED_SEARCH_ERROR]: state => {
    state.getSavedSearchStatus = 'error'
  },
  [GET_SAVED_SEARCH_RESET_STATUS]: state => {
    state.getSavedSearchStatus = ''
  },
  [SAVED_SEARCH_POST]: state => {
    state.postSavedSearchStatus = 'error'
  },
  [SAVED_SEARCH_POST_SUCCESS]: state => {
    state.postSavedSearchStatus = ''
  },
  [SAVED_SEARCH_POST_ERROR]: state => {
    state.postSavedSearchStatus = ''
  }
}

const actions = {
  [ALL_SAVED_SEARCH_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(ALL_SAVED_SEARCH_REQ)
      ApiRest()
        .get('/saved-search')
        .then(({ data }) => {
          data = new IQCollection(data)
          context.commit(ALL_SAVED_SEARCH_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ALL_SAVED_SEARCH_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ALL_SAVED_SEARCH_SUCCESS] (context) {
    context.commit(ALL_SAVED_SEARCH_SUCCESS)
  },
  [GET_SAVED_SEARCH_REQ] (context, savedSearchName) {
    return new Promise((resolve, reject) => {
      context.commit(GET_SAVED_SEARCH_REQ)
      ApiRest()
        .get(`/saved-search/${savedSearchName}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(GET_SAVED_SEARCH_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [GET_SAVED_SEARCH_SUCCESS] (context) {
    context.commit(GET_SAVED_SEARCH_SUCCESS)
  },
  [SAVED_SEARCH_POST] (context, { savedSearchName, searchQuery } = {}) {
    return new Promise((resolve, reject) => {
      context.commit(SAVED_SEARCH_POST)
      ApiRest()
        .post(`/saved-search/${savedSearchName}`, {
          name: savedSearchName,
          search_query: searchQuery
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(SAVED_SEARCH_POST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [SAVED_SEARCH_POST_SUCCESS] (context) {
    context.commit(SAVED_SEARCH_POST_SUCCESS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/saved-search.module.js